import { Label } from '@/components/ui/label'
import type { Visibility } from '@/api/types'

interface VisibilitySelectorProps {
  value: Visibility
  onChange: (next: Visibility) => void
  /** When provided, used as the radio group's name (lets multiple selectors coexist on a page). */
  name?: string
  disabled?: boolean
  /** Hide the legend ("Visibility") for inline placements. */
  hideLegend?: boolean
}

interface Option {
  value: Visibility
  label: string
  hint: string
}

const OPTIONS: Option[] = [
  { value: 'PUBLIC', label: 'Public', hint: 'Visible in browse and at the URL.' },
  { value: 'UNLISTED', label: 'Unlisted', hint: 'Anyone with the link can read; not in browse.' },
  { value: 'PRIVATE', label: 'Private', hint: 'Only you can read.' },
]

export const VisibilitySelector = ({
  value,
  onChange,
  name = 'visibility',
  disabled,
  hideLegend,
}: VisibilitySelectorProps) => (
  <fieldset className="space-y-2" disabled={disabled}>
    {!hideLegend && <legend className="text-sm font-medium">Visibility</legend>}
    <div className="space-y-2">
      {OPTIONS.map((opt) => {
        const id = `${name}-${opt.value}`
        return (
          <div key={opt.value} className="flex items-start gap-3">
            <input
              type="radio"
              id={id}
              name={name}
              value={opt.value}
              checked={value === opt.value}
              onChange={() => onChange(opt.value)}
              className="mt-1"
            />
            <div className="space-y-0.5">
              <Label htmlFor={id} className="text-sm font-medium">
                {opt.label}
              </Label>
              <p className="text-xs text-muted-foreground">{opt.hint}</p>
            </div>
          </div>
        )
      })}
    </div>
  </fieldset>
)
